import React, { useEffect, useState } from "react";
import { Button, Flex, Form, Input } from "antd";
import { useAuth } from "AuthContext";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

const onFinishFailed = (error) => {
    console.log(error);
};

export default function Login() {
    const { user, login } = useAuth();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    
    useEffect(()=>{
        if (user) {
            navigate(searchParams.get("next") || "/");
        }
    },[user, navigate, searchParams])
    return (
        <div
            className="d-flex align-items-center"
            style={{ minHeight: "calc(100vh - 64px)" }}
        >
            <div
                className="bg-white p-4 mx-auto shadow-lg align-center"
                style={{
                    maxWidth: "420px",
                    borderRadius: "8px",
                    flexGrow: "1",
                }}
            >
                <div className="row row-cols-1 row-cols-sm-2 justify-content-between mx-0 align-items-center">
                    <h4 className="mx-0 px-0">Đăng nhập</h4>
                    <div
                        style={{ width: "60px" }}
                        className="d-flex justify-content-center"
                    >
                        <img
                            alt="logo"
                            src={process.env.PUBLIC_URL + "/img/logo.png"}
                            width="60px"
                        />
                    </div>
                </div>
                <div className="mt-3">Đăng nhập vào hệ thống học tập</div>
                <Form
                    name="login"
                    className="mt-3"
                    layout="vertical"
                    labelCol={{
                        span: 24,
                    }}
                    wrapperCol={{
                        span: 24,
                    }}
                    style={{
                        maxWidth: 600,
                        margin: "auto",
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={(values) => {
                        if (loading) return;
                        delete values.remember;
                        login(values, setLoading);
                    }}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Tên đăng nhập hoặc email"
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: "Nhập tên đăng nhập!",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Mật khẩu"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: "Nhập mật khẩu!",
                            },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item>
                        <Flex justify="space-between" align="center">
                            <Link
                                to={{
                                    pathname: "/forget-password",
                                }}
                                className="text-decoration-none"
                            >
                                Quên mật khẩu
                            </Link>
                        </Flex>
                    </Form.Item>

                    <Form.Item label={null} className="mb-0">
                        <Button
                            className="w-100 px-0 mx-0"
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                        >
                            Vào
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
